import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, offeringsService } from '@v2/services';
import type { CreateBitwerxOfferingPayload } from '@v2/types';

export const useCreateBitwerxOffering = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: offeringsService.createBitwerxOffering,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.offerings.bitwerx.all);
    },
  });

  const createBitwerxOffering = async (payload: CreateBitwerxOfferingPayload): Promise<unknown> => {
    try {
      return await mutation.mutateAsync(payload);
    } catch {
      return null;
    }
  };

  return {
    createBitwerxOffering,
    loading: mutation.isLoading,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useCreateBitwerxOffering;
